<template>
  <div id="app">
    <!-- <router-view /> -->
    <keep-alive>
      <router-view v-if="$route.meta.noCache" />
    </keep-alive>
    <router-view v-if="!$route.meta.noCache" />
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    if (sessionStorage.getItem('store')) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem('store'))
        )
      )
      sessionStorage.removeItem('store')
    }
    window.addEventListener('beforeunload', () => {
      function customStringify(v) {
        const cache = new Set()
        return JSON.stringify(v, (key, value) => {
          if (typeof value === 'object' && value !== null) {
            if (cache.has(value)) {
              // Circular reference found
              try {
                // If this value does not reference a parent it can be deduped
                return JSON.parse(JSON.stringify(value))
              } catch (err) {
                // discard key if value cannot be deduped
                return
              }
            }
            // Store value in our set
            cache.add(value)
          }
          return value
        })
      }
      if (this.$store.state) {
        const newStore = Object.assign({}, this.$store.state)
        customStringify(newStore)
        sessionStorage.setItem('store', JSON.stringify(this.$store.state))
      }
    })
  }
}
</script>
<style lang="scss">
#app {
  background-color: $BgColor;
  // background: url("//shopmanage-prod.oss-cn-shenzhen.aliyuncs.com/manage/homebgv2.png") no-repeat;
}
</style>
